/* ============================================================
   WGH Product Page — wgh-product.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Gallery ──────────────────────────────────────────────── */
  function initGallery() {
    const gallery = document.querySelector('.wgh-gallery');
    if (!gallery) return;

    const thumbs     = gallery.querySelectorAll('.wgh-gallery__thumb');
    const mainImg    = gallery.querySelector('.wgh-gallery__main-img img');
    const dots       = gallery.querySelectorAll('.wgh-gallery__dot');
    const prevBtn    = gallery.querySelector('[data-gallery-prev]');
    const nextBtn    = gallery.querySelector('[data-gallery-next]');
    let current      = 0;

    function goTo(idx) {
      current = (idx + thumbs.length) % thumbs.length;

      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === current));
      dots.forEach((d, i)   => d.classList.toggle('is-active', i === current));

      const newSrc = thumbs[current].dataset.src;
      if (mainImg && newSrc) {
        mainImg.style.opacity = '0';
        mainImg.src = newSrc;
        mainImg.onload = () => (mainImg.style.opacity = '1');
      }
    }

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goTo(i));
      thumb.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') goTo(i); });
    });

    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    // Touch swipe on mobile
    let touchStartX = 0;
    const mainWrap = gallery.querySelector('.wgh-gallery__main');
    if (mainWrap) {
      mainWrap.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
      mainWrap.addEventListener('touchend', (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      });
    }

    goTo(0);
  }

  /* ── Variants ─────────────────────────────────────────────── */
  function initVariants() {
    const form = document.querySelector('.wgh-product-form');
    if (!form) return;

    const variantData  = JSON.parse(document.getElementById('wgh-product-json')?.textContent || '{}');
    const variants     = variantData.variants || [];
    const variantInput = form.querySelector('[name="id"]');
    const priceEl      = document.querySelector('.wgh-buybox__price');
    const compareEl    = document.querySelector('.wgh-buybox__compare');
    const savingEl     = document.querySelector('.wgh-buybox__saving');
    const klarnaEl     = document.querySelector('.wgh-buybox__klarna');
    const atcBtn       = form.querySelector('.wgh-btn-atc');
    const atcText      = atcBtn?.querySelector('[data-atc-text]');
    const stickyVar    = document.querySelector('.wgh-sticky-buy__variant');
    const stickyPrice  = document.querySelector('.wgh-sticky-buy__price');

    const selectedOptions = {};

    function findVariant() {
      return variants.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i + 1])
      );
    }

    function updatePrice(variant) {
      if (!variant) return;
      const price   = (variant.price / 100).toFixed(2).replace('.', ',');
      const compare = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2).replace('.', ',') : null;

      if (priceEl)  priceEl.textContent   = '€' + price;
      if (stickyPrice) stickyPrice.textContent = '€' + price;

      if (compareEl) {
        compareEl.style.display = compare ? '' : 'none';
        if (compare) compareEl.textContent = '€' + compare;
      }
      if (savingEl && compare) {
        const saved = ((variant.compare_at_price - variant.price) / 100).toFixed(2).replace('.', ',');
        savingEl.textContent = 'Bespaar €' + saved;
        savingEl.style.display = '';
      } else if (savingEl) {
        savingEl.style.display = 'none';
      }

      const klarnaPart = (variant.price / 300).toFixed(2).replace('.', ',');
      if (klarnaEl) klarnaEl.textContent = `Of 3× €${klarnaPart} met Klarna · Incl. btw`;
    }

    function updateAtcBtn(variant) {
      if (!atcBtn) return;
      const available = variant && variant.available;
      atcBtn.disabled = !available;
      atcBtn.style.opacity = available ? '1' : '0.5';
      if (atcText) atcText.textContent = available ? 'In winkelwagen' : 'Uitverkocht';
    }

    function onSwatchClick(e) {
      const btn = e.currentTarget;
      const optionIndex = parseInt(btn.dataset.optionIndex);
      const optionValue = btn.dataset.optionValue;

      // Deselect siblings
      btn.closest('.wgh-swatch-row').querySelectorAll('.wgh-swatch').forEach((s) =>
        s.classList.remove('is-selected')
      );
      btn.classList.add('is-selected');

      // Update display label
      const labelEl = btn.closest('.wgh-option-group').querySelector('.wgh-option-label__value');
      if (labelEl) labelEl.textContent = optionValue;

      selectedOptions[optionIndex] = optionValue;

      // Update sticky bar variant label
      if (stickyVar) {
        const parts = Object.values(selectedOptions).filter(Boolean);
        stickyVar.textContent = parts.join(' · ');
      }

      const variant = findVariant();
      if (variant) {
        form.querySelectorAll('[name="id"]').forEach((el) => { el.value = variant.id; });
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        updatePrice(variant);
        updateAtcBtn(variant);
        // Update gallery if variant has image
        if (variant.featured_image) {
          const thumbIndex = Array.from(document.querySelectorAll('.wgh-gallery__thumb'))
            .findIndex((t) => t.dataset.src && t.dataset.src.includes(variant.featured_image.src.split('?')[0].split('/').pop()));
          if (thumbIndex >= 0) document.querySelectorAll('.wgh-gallery__thumb')[thumbIndex].click();
        }
      } else {
        updateAtcBtn(null);
      }
    }

    document.querySelectorAll('.wgh-swatch[data-option-index]').forEach((btn) => {
      btn.addEventListener('click', onSwatchClick);
    });

    // Init from the variant the server already selected (respects ?variant= URL param)
    const initialId = parseInt(variantInput?.value);
    const initialVariant = variants.find((v) => v.id === initialId)
      || variants.find((v) => v.available)
      || variants[0];
    if (initialVariant) {
      document.querySelectorAll('.wgh-swatch').forEach((s) => s.classList.remove('is-selected'));
      initialVariant.options.forEach((opt, i) => {
        selectedOptions[i + 1] = opt;
        const btn = document.querySelector(`.wgh-swatch[data-option-index="${i + 1}"][data-option-value="${CSS.escape(opt)}"]`);
        if (btn) {
          btn.classList.add('is-selected');
          const labelEl = btn.closest('.wgh-option-group')?.querySelector('.wgh-option-label__value');
          if (labelEl) labelEl.textContent = opt;
        }
      });
      form.querySelectorAll('[name="id"]').forEach((el) => { el.value = initialVariant.id; });
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      updatePrice(initialVariant);
      updateAtcBtn(initialVariant);
    }
  }

  /* ── Quantity stepper ─────────────────────────────────────── */
  function initQty() {
    document.querySelectorAll('.wgh-qty').forEach((wrap) => {
      const input  = wrap.querySelector('input');
      const minBtn = wrap.querySelector('[data-qty-minus]');
      const plusBtn = wrap.querySelector('[data-qty-plus]');
      if (!input) return;

      minBtn?.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        if (v > 1) input.value = v - 1;
      });
      plusBtn?.addEventListener('click', () => {
        input.value = (parseInt(input.value) || 1) + 1;
      });
      input.addEventListener('change', () => {
        if (parseInt(input.value) < 1 || isNaN(parseInt(input.value))) input.value = 1;
      });
    });
  }

  /* ── Add to cart (AJAX) ───────────────────────────────────── */
  function initAddToCart() {
    const form   = document.querySelector('.wgh-product-form');
    const atcBtn = form?.querySelector('.wgh-btn-atc');
    if (!form || !atcBtn) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      atcBtn.disabled = true;
      const textEl = atcBtn.querySelector('[data-atc-text]');
      const orig   = textEl?.textContent || 'In winkelwagen';
      if (textEl) textEl.textContent = 'Toevoegen…';

      const data = new FormData(form);
      try {
        const res  = await fetch('/cart/add.js', { method: 'POST', body: data });
        const json = await res.json();
        if (json.id) {
          if (textEl) textEl.textContent = '✓ Toegevoegd!';
          // Trigger cart drawer / mini-cart if theme supports it
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: json }));
          setTimeout(() => {
            if (textEl) textEl.textContent = orig;
            atcBtn.disabled = false;
          }, 2000);
        } else {
          throw new Error(json.description || 'Error');
        }
      } catch (err) {
        if (textEl) textEl.textContent = orig;
        atcBtn.disabled = false;
        console.error('[WGH] Add to cart error:', err);
      }
    });
  }

  /* ── Tab navigatie — klik scrollt naar sectie, scroll-spy toont actieve tab ── */
  function initTabs() {
    const btns = document.querySelectorAll('.wgh-tabs-nav .wgh-tab-btn');
    if (!btns.length) return;

    function setActive(btn) {
      btns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    }

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = document.getElementById(btn.dataset.tabTarget);
        if (!target) return;
        setActive(btn);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Scroll-spy: activeer tab van sectie die het hoogst in beeld is
    const sections = Array.from(btns)
      .map((btn) => ({ btn, el: document.getElementById(btn.dataset.tabTarget) }))
      .filter(({ el }) => el);

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const mid = window.scrollY + window.innerHeight * 0.35;
        let active = sections[0];
        for (const s of sections) {
          if (s.el.getBoundingClientRect().top + window.scrollY <= mid) active = s;
        }
        if (active) setActive(active.btn);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  function initTabAccordion() {}

  /* ── FAQ accordion ───────────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll('.wgh-accordion details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        // Close other open items
        detail.closest('.wgh-accordion')
              .querySelectorAll('details[open]')
              .forEach((other) => { if (other !== detail) other.open = false; });
      });
    });
  }


  /* ── Sticky buy bar visibility ───────────────────────────── */
  function initStickyBar() {
    const bar    = document.querySelector('.wgh-sticky-buy');
    const buybox = document.querySelector('.wgh-buybox');
    if (!bar || !buybox) return;

    const observer = new IntersectionObserver(
      ([entry]) => { bar.style.display = entry.isIntersecting ? 'none' : 'flex'; },
      { threshold: 0.1 }
    );
    observer.observe(buybox);
  }

  /* ── "Verder lezen" → scroll naar productomschrijving ─────── */
  function initReadMore() {
    const link = document.querySelector('.wgh-buybox__read-more');
    if (!link) return;
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('pi-omschrijving');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ── "Bekijk de afmetingen hier" → scroll naar specificaties ── */
  function initGotoSpecs() {
    document.querySelectorAll('.wgh-goto-specs').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById('pi-specificaties');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Sticky buy bar → scroll to form ────────────────────── */
  function initStickyBarClick() {
    const btn = document.querySelector('.wgh-sticky-buy__btn');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const buybox = document.querySelector('.wgh-buybox');
      if (buybox) buybox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initDefaultOpenTab() {}

  /* ── Delivery timeline helpers ────────────────────────────── */
  function _addWorkingDays(startDate, days, blocked) {
    var d = new Date(startDate.getTime());
    var n = 0;
    while (n < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow === 0 || dow === 6) continue;
      var iso = d.getFullYear() + '-'
        + String(d.getMonth() + 1).padStart(2, '0') + '-'
        + String(d.getDate()).padStart(2, '0');
      if (blocked.indexOf(iso) !== -1) continue;
      n++;
    }
    return d;
  }

  // Returns the total weekday size of vacation clusters that overlap [today, delivery].
  // Scans 60 days back so the full cluster is counted even when today is mid-vacation.
  // Only adds extra days when the vacation actually falls within the delivery window —
  // so a 2-3 day product whose delivery lands before the vacation gets no extra days.
  function _vacationExtraDays(today, delivery, blocked) {
    if (!blocked.length) return 0;
    var blockedSet = new Set(blocked);
    var scan = new Date(today); scan.setDate(scan.getDate() - 60);
    var scanEnd = new Date(delivery); scanEnd.setDate(scanEnd.getDate() + 30);
    var clusters = [];
    var current  = null;
    var d = new Date(scan);
    while (d <= scanEnd) {
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) {
        var iso = d.getFullYear() + '-'
          + String(d.getMonth() + 1).padStart(2, '0') + '-'
          + String(d.getDate()).padStart(2, '0');
        if (blockedSet.has(iso)) {
          if (!current) current = { start: new Date(d), end: new Date(d), size: 0 };
          current.end = new Date(d);
          current.size++;
        } else if (current) {
          clusters.push(current);
          current = null;
        }
      }
      d.setDate(d.getDate() + 1);
    }
    if (current) clusters.push(current);
    var extra = 0;
    clusters.forEach(function (c) {
      if (c.end >= today && c.start <= delivery) extra += c.size;
    });
    return extra;
  }

  function _buildDeliveryHTML(rawDays, blocked, names, adjustedMaxDays) {
    names = names || {};
    var parts    = String(rawDays).split('-').map(Number).filter(function (n) { return n > 0; });
    var rawMax   = parts.length ? Math.max.apply(null, parts) : 2;
    var today    = new Date();
    today.setHours(0, 0, 0, 0);
    // When an adjusted day count is supplied (after vacation calculation), use it for the
    // delivery date so the tooltip date is consistent with the displayed "X werkdagen".
    // _addWorkingDays without blocked is equivalent to _addWorkingDays(rawMax, blocked) when
    // adjustedMaxDays already incorporates the vacation overlap.
    var delivery = adjustedMaxDays != null
      ? _addWorkingDays(today, adjustedMaxDays, [])
      : _addWorkingDays(today, rawMax, blocked);
    var maxDays  = adjustedMaxDays != null ? adjustedMaxDays : rawMax;

    var dayNL = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
    var monNL = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    var delivStr = dayNL[delivery.getDay()] + ' ' + delivery.getDate() + ' ' + monNL[delivery.getMonth()];

    // Collect blocked dates within the delivery window (today < d <= delivery)
    var windowDates = [];
    blocked.forEach(function (iso) {
      var d = new Date(iso + 'T00:00:00');
      if (d > today && d <= delivery) {
        windowDates.push({
          iso:   iso,
          label: dayNL[d.getDay()] + ' ' + d.getDate() + ' ' + monNL[d.getMonth()],
          name:  names[iso] || 'Sluitingsdag',
        });
      }
    });

    // Group consecutive dates with the same name into ranges
    var groups = [];
    windowDates.forEach(function (item) {
      var last = groups[groups.length - 1];
      if (last && last.name === item.name) {
        var prev = new Date(last.lastIso + 'T00:00:00');
        prev.setDate(prev.getDate() + 1);
        if (prev.getTime() === new Date(item.iso + 'T00:00:00').getTime()) {
          last.endLabel = item.label;
          last.lastIso  = item.iso;
          return;
        }
      }
      groups.push({ startLabel: item.label, endLabel: null, name: item.name, lastIso: item.iso });
    });

    var holidaysHtml = '';
    if (groups.length) {
      holidaysHtml = '<div class="wgh-dtip__holidays">'
        + '<div class="wgh-dtip__holidays-hdr">Gesloten in deze periode</div>';
      groups.forEach(function (g) {
        var dateRange = g.endLabel ? g.startLabel + '–' + g.endLabel : g.startLabel;
        holidaysHtml += '<div class="wgh-dtip__holiday-row">'
          + '<span class="wgh-dtip__hol-date">' + dateRange + '</span>'
          + '<span class="wgh-dtip__hol-name">' + g.name + '</span>'
          + '</div>';
      });
      holidaysHtml += '</div>';
    }

    function step(dateStr, dotCls, label) {
      return '<div class="wgh-dtip__step">'
        + '<span class="wgh-dtip__date">' + (dateStr || '') + '</span>'
        + '<span class="wgh-dtip__dot' + (dotCls ? ' ' + dotCls : '') + '"></span>'
        + '<span class="wgh-dtip__label">' + label + '</span>'
        + '</div>';
    }

    return '<button class="wgh-dtip__close" aria-label="Sluiten">×</button>'
      + '<div class="wgh-dtip__title">Verwachte levertijd voor jouw bestelling</div>'
      + '<div class="wgh-dtip__timeline">'
      + step('Vandaag', 'is-today', 'Bestelling plaatsen')
      + '<div class="wgh-dtip__conn"></div>'
      + step('', '', 'Productie in werkplaats')
      + '<div class="wgh-dtip__conn"></div>'
      + step(delivStr, 'is-delivery', 'Verwachte bezorging (' + maxDays + ' werkdagen)')
      + '</div>'
      + holidaysHtml
      + '<div class="wgh-dtip__note">Wij bezorgen in Nederland en België. Voor België geldt de indicatie +1 werkdag extra. Bezorger kan altijd vertraging oplopen, hier hebben wij geen invloed op. Bovenstaande is ter indicatie.</div>'
      + '<div class="wgh-dtip__arrow"></div>';
  }

  /* ── Blocked-dates loader with sessionStorage cache ──────── */
  function _fetchBlocked(apiBase, cb) {
    var KEY = 'wgh_blocked', TTL = 3600000;
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.ts < TTL) { cb(c.blocked, c.names); return; }
    } catch (e) {}
    fetch(apiBase + '/api/public/blocked-dates')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var bl = Array.isArray(d.blocked) ? d.blocked : [];
        var nm = (d.names && typeof d.names === 'object') ? d.names : {};
        try { sessionStorage.setItem(KEY, JSON.stringify({ blocked: bl, names: nm, ts: Date.now() })); } catch (e) {}
        cb(bl, nm);
      })
      .catch(function () { cb([], {}); });
  }

  /* ── Delivery info tooltip (hover + tap) ─────────────────── */
  function initDeliveryInfo() {
    var infoBtn = document.querySelector('.wgh-delivery-info');
    if (!infoBtn) return;

    var deliveryEl = document.querySelector('.wgh-buybox__delivery');
    var rawDays    = deliveryEl ? (deliveryEl.dataset.delivery || '2-3') : '2-3';
    var apiBase    = deliveryEl ? (deliveryEl.dataset.api || '') : '';
    var blocked    = [];
    var strongEl   = deliveryEl ? deliveryEl.querySelector('strong') : null;

    var tip = document.createElement('div');
    tip.className = 'wgh-delivery-tooltip';
    tip.style.cssText = 'display:none;position:absolute;z-index:99;pointer-events:none;';
    tip.innerHTML = _buildDeliveryHTML(rawDays, blocked, {});
    document.body.appendChild(tip);

    tip.addEventListener('click', function (e) {
      if (e.target.closest('.wgh-dtip__close')) hide();
    });

    if (apiBase) {
      _fetchBlocked(apiBase, function (bl, names) {
        blocked = bl;

        var today0  = new Date(); today0.setHours(0, 0, 0, 0);
        var parts0  = String(rawDays).split('-').map(Number).filter(function (n) { return n > 0; });
        var actualParts = parts0.map(function (n) {
          var del = _addWorkingDays(today0, n, blocked);
          return n + _vacationExtraDays(today0, del, blocked);
        });
        var adjustedMax = actualParts.length ? actualParts[actualParts.length - 1] : null;

        tip.innerHTML = _buildDeliveryHTML(rawDays, blocked, names, adjustedMax);

        var displayDays = actualParts.length === 1
          ? actualParts[0]
          : actualParts[0] + '-' + actualParts[actualParts.length - 1];
        if (strongEl) strongEl.textContent = displayDays + ' werkdagen';
      });
    } else {
      if (strongEl) strongEl.textContent = rawDays + ' werkdagen';
    }

    var supportsHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    function show() {
      tip.style.display = 'block';
      var r   = infoBtn.getBoundingClientRect();
      var tw  = tip.offsetWidth;
      var th  = tip.offsetHeight;
      var gap = 12;
      var top, left;

      var sy = window.scrollY || window.pageYOffset;
      var sx = window.scrollX || window.pageXOffset;

      if (!supportsHover) {
        // Mobile: center horizontally, always above the button
        left = sx + Math.max(8, Math.min((window.innerWidth - tw) / 2, window.innerWidth - tw - 8));
        top  = sy + Math.max(8, r.top - th - gap);
      } else {
        // Desktop: anchor to button center, fall below if no room above
        top  = sy + r.top - th - gap;
        left = sx + r.left + r.width / 2 - tw / 2;
        if (r.top - th - gap < 8) top = sy + r.bottom + gap;
        left = Math.max(8, Math.min(left, sx + window.innerWidth - tw - 8));
      }

      tip.style.top  = top  + 'px';
      tip.style.left = left + 'px';

      // Arrow points to button center
      var arrow = tip.querySelector('.wgh-dtip__arrow');
      if (arrow) {
        var btnCX = r.left + r.width / 2 - parseFloat(tip.style.left);
        arrow.style.left = Math.max(16, Math.min(btnCX, tw - 16)) + 'px';
      }
    }

    function hide() { tip.style.display = 'none'; }

    if (supportsHover) {
      infoBtn.addEventListener('mouseenter', show);
      infoBtn.addEventListener('mouseleave', hide);
    } else {
      infoBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        tip.style.display === 'none' ? show() : hide();
      });
      document.addEventListener('click', hide);
    }
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    initGallery();
    initVariants();
    initQty();
    initAddToCart();
    initTabs();
    initTabAccordion();
    initDefaultOpenTab();
    initFaq();
    initStickyBar();
    initStickyBarClick();
    initReadMore();
    initGotoSpecs();
    initDeliveryInfo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
